export const scenarios = [
    {
        id: 1,
        title: "Gestione Biblioteca",
        description: "Gestione di libri, prestiti e utenti di una biblioteca comunale.",
    },
    {
        id: 2,
        title: "Magazzino Elettronica",
        description: "Sistema per tracciare componenti elettronici, scorte e fornitori.",
    },
    {
        id: 3,
        title: "Registro Voti Scolastici",
        description: "Applicazione per gestire studenti, materie e voti di una classe.",
    },
    {
        id: 4,
        title: "Prenotazione Cinema",
        description: "Sistema di prenotazione posti, film in programmazione e sale.",
    },
    {
        id: 5,
        title: "Autoconcessionaria",
        description: "Gestione del parco auto, vendite effettuate e clienti.",
    },
    {
        id: 6,
        title: "Menu Ristorante",
        description: "Gestione dei piatti, ingredienti, allergeni e ordini.",
    },
    {
        id: 7,
        title: "Turni Ospedalieri",
        description: "Organizzazione dei turni di medici e infermieri nei vari reparti.",
    },
    {
        id: 8,
        title: "Playlist Musicale",
        description: "Gestione di brani, artisti, album e playlist personali.",
    },
    {
        id: 9,
        title: "Torneo Sportivo",
        description: "Gestione di squadre, partite, risultati e classifiche.",
    },
    {
        id: 10,
        title: "Gestione Spese Condominiali",
        description: "Tracciamento delle spese, millesimi e pagamenti dei condomini.",
    },
    {
        id: 11,
        title: "Gestione Palestra",
        description: "Gestione abbonamenti, corsi, istruttori e accessi degli iscritti.",
    },
    {
        id: 12,
        title: "Prenotazione Hotel",
        description: "Sistema per gestire camere, prenotazioni, check-in e check-out.",
    },
    {
        id: 13,
        title: "Agenzia Viaggi",
        description: "Gestione pacchetti turistici, prenotazioni clienti e destinazioni.",
    },
    {
        id: 14,
        title: "Agenzia Immobiliare",
        description: "Archivio immobili in vendita/affitto, clienti e appuntamenti.",
    },
    {
        id: 15,
        title: "E-commerce Semplice",
        description: "Gestione catalogo prodotti, carrello, ordini e spedizioni.",
    },
    {
        id: 16,
        title: "Compagnia Aerea",
        description: "Gestione voli, tratte, biglietti e passeggeri.",
    },
    {
        id: 17,
        title: "Videoteca/Streaming",
        description: "Catalogo film, noleggi/visioni, utenti e recensioni.",
    },
    {
        id: 18,
        title: "Gestione Eventi",
        description: "Organizzazione conferenze, partecipanti, biglietti e location.",
    },
    {
        id: 19,
        title: "Parcheggio Automatizzato",
        description: "Gestione posti auto, ticket, tariffe orarie e pagamenti.",
    },
    {
        id: 20,
        title: "Clinica Veterinaria",
        description: "Gestione pazienti (animali), proprietari, visite e vaccinazioni.",
    }
];
